import { render, staticRenderFns } from "./DraggableAccordions.vue?vue&type=template&id=ae4626ba&scoped=true"
import script from "./DraggableAccordions.vue?vue&type=script&lang=js"
export * from "./DraggableAccordions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae4626ba",
  null
  
)

export default component.exports